class Sound { }
export default Sound;